import * as React from 'react';
import {Flex, Dropdown} from '@priority-software/priority-style-react';
import EntityIcon from '../../../../components/Common/EntityIcon/EntityIcon';
import List from '../../../../components/Common/List';
import {executeActivation} from '../../actions/directActivations';
import {showEntityHelpMessage} from '../../../../_shared/Help/actions/helpActions';
import {Label} from '../../../../components/Common/Label';

export const ActivationsList = props => {
    return (
        <Dropdown.Section gradient paddingTop>
            <List
                {...props}
                renderItem={DirectActivation}
                autoHeight
                autoHeightMax={props.autoHeightMax}
            />
        </Dropdown.Section>
    );
};

export const DirectActivation = ({item, index, isLastIndex}) => {
    return (
        <Dropdown.Item
            key={item.title || index}
            onClick={e => executeActivation(e, item)}
            index={index}
            divider={!isLastIndex}
            onContextMenu={e => showEntityHelpMessage(item.exec, e?.target)}
            componentClasses="activation-item"
            title={item.title}
        >
            <Flex justifyContent="flex-start">
                <EntityIcon type={item.type} />

                <Label skin="paragraph-2" startPadding textColor="primary-700">
                    {item.title}
                </Label>
            </Flex>
        </Dropdown.Item>
    );
};
